
import React, { Component } from 'react';

import './BlockedContentCountdown.css';

const textPadding = ( filler, value, width) => {
  let str = `${value}`;
  while( width > str.length) {
    str = `${filler.slice( 0, width-str.length)}${str}`;
  }
  return str;
}

class BlockedContentCountdown extends Component {

  constructor( props) {
    super( props);
    const now = Date.now();
    this.state = {
      msUntil: props.blockedUntil - now,
    };
  }

  render() {
    const backgroundImage = `url("${this.props.backgroundImageUrl}")`;
    const ms = Math.floor( this.state.msUntil);
    const s = Math.floor( ms / 1000);
    const m = Math.floor( s / 60);
    const h = Math.floor( m / 60);
    const d = Math.floor( h / 24);

    const step = 1000;  // NOTE 1 second
    if( ms > step) setTimeout( _ => this.setState({ msUntil: ms - step}), step);
    else setTimeout( _ => window.location.reload(), ms);   // REVIEW considerar un metodo react puro que no dependa de window

    return (
      <div className='BlockedContentCountdown' style={{ backgroundImage }}>
        <p>Time until start: {d} day{d===1?'':'s'} - {textPadding('0',h%24,2)} : {textPadding('0',m%60,2)} : {textPadding('0',s%60,2)}</p>
      </div>
    );
  }
}

export default BlockedContentCountdown;
